import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { getSnapshot } from 'mobx-state-tree';
import { AvGroup, AvInput, AvForm, AvFeedback } from 'availity-mobx-reactstrap-validation';
import { Label, Input, FormGroup } from 'reactstrap';

import ReceivingAccountFormState from 'js/stores/forms/ReceivingAccountFormState';
import ErrorDisplay from 'js/components/common/ErrorDisplay';
import Button from 'js/components/common/Button';
import SubmitRow from 'js/components/core/Modal/SubmitRow';

import Container from './Container';
import Title from './Title';

@inject('page')
@observer
export default class Form extends Component {
  receivingAccountForm = ReceivingAccountFormState.create({
    receivingAccount: this.props.page.bankAccount ? getSnapshot(this.props.page.bankAccount) : {},
  });

  onSubmit = () => this.props.page.receivingAccountSaved(this.receivingAccountForm.receivingAccount);

  render() {
    const receivingAccountForm = this.receivingAccountForm;
    const receivingAccount = receivingAccountForm.receivingAccount;

    return (
      <Container>
        <AvForm onValidSubmit={this.onSubmit}>
          <Title>Receiving account</Title>
          <AvGroup>
            <Label for="route">Routing Number</Label>
            <AvInput
              name="route"
              id="route"
              onChange={receivingAccount.setRoute}
              value={receivingAccount.route}
              required
            />
            <AvFeedback>Please enter your bank routing number</AvFeedback>
          </AvGroup>

          <AvGroup>
            <Label for="number">Account Number</Label>
            <AvInput
              name="number"
              id="number"
              onChange={receivingAccount.setNumber}
              value={receivingAccount.number}
              onFocus={receivingAccountForm.clearNumber}
              required
            />
            <AvFeedback>Please enter your bank account number</AvFeedback>
          </AvGroup>

          <FormGroup>
            <Label for="type">Account Type</Label>
            <Input
              type="select"
              name="select"
              id="type"
              value={receivingAccount.type}
              onChange={receivingAccount.setType}>
              <option value="Checking">Checking</option>
              <option value="Savings">Savings</option>
              <option value="BusinessCK">Business Checking</option>
            </Input>
          </FormGroup>

          <ErrorDisplay>{receivingAccountForm.error}</ErrorDisplay>

          <SubmitRow>
            <Button autoFocus={receivingAccountForm.receivingAccount.isFilledIn} type="submit">
              Save
            </Button>
          </SubmitRow>
        </AvForm>
      </Container>
    );
  }
}
